<div class="my-performance-card">
    <cmps-card-component
        class="insight-component-item"
        [cardNameLabel]="_i18n._771_MY_PERFORMANCE | translate"
        [isLoading]="state.pending?.reload"
        [hasFilterAction]="false"
        [disabledDropdown]="true"
        [isExpanded]="_isExpanded"
        [hasRefreshAction]="_isExpanded === false && state.pending.hasData"
        (refreshAction)="_onReload()"
        [hasExpandAction]="state.pending.hasData"
        (expandAction)="_onExpandClick()"
        [data]="bodyContent"
    ></cmps-card-component>
</div>

<ng-template #bodyContent>
    <ng-container *ngIf="!state.pending.hasData && !state.pending.reload">
        <div class="my-performance-card--no-data">
            <h2 class="my-performance-card--no-data-value">
                {{ _i18n._711_NO_DATA_AVAILABLE | translate }}
            </h2>
        </div>
    </ng-container>

    <ng-container *ngIf="_isExpanded === false && state.pending.hasData">
        <cmps-card-header-row-component
            *ngIf="_isExpanded === false"
            [cardHeaderLabel]="state?.headerData?.titleLabel"
            [timePeriod]="state?.headerData?.periodDate"
            [isShowingIcon]="state?.headerData?.hasHeaderIcon"
            [isHumanView]="state?.headerData?.isHumanView"
        ></cmps-card-header-row-component>
        <ng-container>
            <div class="cmps-insight-coaching-performance-container">
                <cmps-insight-coaching-performance
                    [label]="_i18n._9945_TOTAL_PERFORMANCE | translate"
                    [isTotalPerformance]="true"
                    [isParentPillar]="true"
                    [data]="
                        state?.totalPerformancePillar?.parentPillar
                            .progressBarData
                    "
                    [dropdownContent]="
                        state?.totalPerformancePillar?.parentPillar
                            .dropdownContent
                    "
                    [childPillar]="childPillar"
                    (selectedValue)="_onSelectItem($event)"
                >
                </cmps-insight-coaching-performance>
                <div
                    #childPillars
                    *ngIf="state?.totalPerformancePillar?.childPillars"
                >
                    <ng-container
                        *ngFor="
                            let i of state?.totalPerformancePillar?.childPillars
                        "
                    >
                        <cmps-insight-coaching-performance
                            *ngIf="i?.isVisible"
                            [label]="i.titleLabel"
                            [isTotalPerformance]="false"
                            [isParentPillar]="!i.isChildPillar"
                            [data]="i.progressBarData"
                            (closeAction)="_closeAction(i.viewType)"
                        ></cmps-insight-coaching-performance>
                    </ng-container>
                </div>
            </div>
        </ng-container>

        <ng-container>
            <div
                class="cmps-insight-coaching-performance-container"
                *ngFor="let pillar of state?.pillarsData; let i = index"
            >
                <cmps-insight-coaching-performance
                    [label]="pillar.parentPillar.titleLabel"
                    [isTotalPerformance]="false"
                    [isParentPillar]="true"
                    [data]="pillar.parentPillar.progressBarData"
                    [dropdownContent]="pillar.parentPillar.dropdownContent"
                    [childPillar]="childPillars"
                    (selectedValue)="_onSelectItem($event, i)"
                >
                </cmps-insight-coaching-performance>
                <div
                    #childPillars
                    *ngIf="pillar.childPillars"
                >
                    <ng-container *ngFor="let cc of pillar.childPillars">
                        <cmps-insight-coaching-performance
                            *ngIf="cc.isVisible"
                            [label]="cc.titleLabel"
                            [isTotalPerformance]="false"
                            [isParentPillar]="!cc.isChildPillar"
                            [data]="cc.progressBarData"
                            (closeAction)="_closeAction(cc.viewType, i)"
                        ></cmps-insight-coaching-performance>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="_isExpanded === true">
        <div cmpsInsightExplorerWidget></div>
    </ng-container>
</ng-template>
